import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import GrievanceList from '../components/Grievance/GrievanceList';
import Header from '../components/Grievance/Header';
import axios from 'axios';

const Grievance = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [grievances, setGrievances] = useState([]);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.grievancePermission) {
          const grievancePermissionFromParent = props.grievancePermission;
          
          if (grievancePermissionFromParent == 0) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
          }
          else {
                setIsLoading(false);
          }
        }
    
      }, [props.grievancePermission]);

    // useEffect(() => {
    //     const getGrievances = async () => {
    //         const grievanceFromServer = await fetchGrievances();
    //         if(grievanceFromServer === undefined){
    //             console.log("Undefined data");
    //         }
    //         else{
    //             setGrievances(grievanceFromServer);
    //         }
    //     };

    //     getGrievances();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    // const fetchGrievances = async () => {
    //     const res = await fetch(
    //         REACT_APP_API_BACKEND_URL + '/api/grievance/getgrievancelist'
    //     );
    //     const data = await res.json();
    //     // Map id into the list to have unique key
    //     return data.GrievanceList;
    // };

    useEffect(() => {
        fetchGrievances();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStorage.getItem('badgeID')]);

    async function fetchGrievances() {
        if (localStorage.getItem('badgeID')) {
            const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/getgrievancelist';
        axios
            .post(url, { userID: localStorage.getItem('badgeID') })
            .then((response) => {
                if(response === undefined){
                    console.log("Undefined data");
                }
                else{
                    for (let i = 0; i < response.data.GrievanceList.length; i++) {
                        if(response.data.GrievanceList[i].grievanceStatusID == 5 && !response.data.GrievanceList[i].validatedByID){
                            response.data.GrievanceList[i].grievanceStatusName = "Open";
                        }
                        else if(response.data.GrievanceList[i].grievanceStatusID == 5 && response.data.GrievanceList[i].validatedByID){
                            response.data.GrievanceList[i].grievanceStatusName = "Rejected";
                        }
                        else if (response.data.GrievanceList[i].grievanceStatusID == 6){
                            response.data.GrievanceList[i].grievanceStatusName = "Validation";
                        }
                    }
                    setGrievances(response.data.GrievanceList.reverse());
                }
            })
            .catch((err) => console.error(err));
        }
    }

    const GrievanceTable = () => {
        return (
            <Fragment>
                {grievances.length > 0 ? (
                    <GrievanceList grievances={grievances} />
                ) : (
                    <div>No grievance to show</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container-fluid'
                        }`}
                    >
                        <Header />
                        <div className='table-wrapper'>
                            <GrievanceTable />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Grievance;